const getSalesDefaultState = () => {
    return {
        proceedsecondComponent: false
    }
}
const state = getSalesDefaultState();

const getters = {
    getSecond: state => state.proceedsecondComponent
}

const actions = {
    async updateSecond({ commit }, proceed) {
        commit('updateSecond', proceed);
    },
}

const mutations = {
    updateSecond(state, proceed) {
        state.proceedsecondComponent = proceed
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}